import Configs from './assets/configurations';
import App from './screens';

const AppName = Configs.Settings.APP_NAME;
export { App, AppName };
